import fetch from "lib/fetch";
import type { DeviceInterface } from "types/reference";

type DeviceListResponse = { data: Array<DeviceInterface> };

export const getDevicesRequest = (languageCode: string) =>
    fetch.get<DeviceListResponse>(`reference/device/${languageCode}`);
